<template>
  <div class="ad-grid" v-if="hasBanner">
    <carousel
      ref="carousel"
      :perPage="1"
      :centerMode="true"
      :mouseDrag="true"
      :paginationEnabled="false"
      :scrollPerPage="false">
      <slide v-for="(item, index) in source" :key="index" class="ad-grid-container">
        <div class="ad-grid-800_200">
          <a :href="`${item.url}${item.anchor}`" :target="item.action" @click="$emit('click', item)">
            <img :src="item.img" :alt="item.alt" />
          </a>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

const props = {
  source: Array,
};

const components = {
  Carousel,
  Slide,
};

const computed = {
  hasBanner() {
    return this.source.length > 0;
  },
};

export default {
  name: 'ad-slider',
  props,
  components,
  computed,
};
</script>
